var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M681.212 147.368L797.463 147.368C807.049 147.368 814.819 153.548 814.819 161.171L814.819 362.384C814.819 370.006 807.049 376.186 797.463 376.186L681.212 376.186C671.626 376.186 663.855 370.006 663.855 362.384L663.855 161.171C663.855 153.548 671.626 147.368 681.212 147.368Z",
    fill: "#ff3e3e",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.791 442.323L126.209 442.323C99.1138 442.323 93.6974 428.508 114.111 411.466L446.772 133.753C482.797 103.679 541.203 103.679 577.228 133.753L909.889 411.466C930.303 428.508 924.886 442.323 897.791 442.323Z",
    fill: "#ff3e3e",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.594 429.832L463.154 208.706C490.5 186.02 534.725 186.162 561.933 209.023L827.347 432.038C835.062 438.52 841.316 452.063 841.316 462.286L841.316 821.607C841.316 858.431 812.181 888.283 776.242 888.283L250.865 888.283C214.739 888.283 185.258 858.276 185.019 821.261L182.684 459.965C182.618 449.75 188.846 436.259 196.594 429.832Z",
    fill: "#ffeca6",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.052 529.206L621.567 529.206C642.279 529.206 659.069 544.35 659.069 563.031L659.069 888.283L364.931 888.283L364.931 569.001C364.931 547.022 384.684 529.206 409.052 529.206Z",
    fill: "#8ed6ff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.6c3f0b425f1fc3c41bc368da594826bd.svg";
export { ForwardRef as ReactComponent };